// FacebookAnalyticsConfig.js
export let fbAnalyticsConfig = { blocked_params: [] };

export function setFBAnalyticsConfig(config) {
  fbAnalyticsConfig = config || { blocked_params: [] };
}

export function filterBlockedParams(obj) {
  if (!obj) return obj;
  const filtered = { ...obj };
  const { blocked_params = [] } = fbAnalyticsConfig || {};
  blocked_params.forEach((param) => {
    if (filtered.hasOwnProperty(param)) {
      delete filtered[param];
    }
  });
  return filtered;
} 